
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wrapped/set-10/[[...slug]]",
      function () {
        return require("private-next-pages/wrapped/set-10/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wrapped/set-10/[[...slug]]"])
      });
    }
  